import Cookies from 'js-cookie';

import { CookiesItems } from '@shared/types/enums/global.enum';
import { ProductsForUser } from '@widgets/Auth/model/types/productsForUser';

export const getCookiesProductsForUser = <T>(item: keyof ProductsForUser): T => {
  return JSON.parse(Cookies.get(CookiesItems.PRODUCTS_FOR_USER) || '{}')?.[item] ?? [];
};

export const setCookiesProductsForUser = (props: Partial<ProductsForUser>) => {
  Cookies.set(
    CookiesItems.PRODUCTS_FOR_USER,
    JSON.stringify({ ...JSON.parse(Cookies.get(CookiesItems.PRODUCTS_FOR_USER) || '{}'), ...props })
  );
};
